import React from 'react';

const Loading = () => {
  return (
    <h3 id='loading-icon'>Chargement de la page...</h3>
  );
};

export default Loading;
